module.exports = __webpack_public_path__ + "static/media/conexion_hexagono_interno.119f06ee.png";